const model = {
    submitting: false,
    errors: null,
    userDetails: null,
    success: false,
};

export default model;
